import Component from "../../classes/Component";

const mapSelector = '#js-map'

export default function () {

    return new Component({
        name: 'map',
        requiredTargets: [mapSelector],
        onInit() {
            ymaps.ready(init);
            function init() {
                // Создание карты.
                const myMap = new ymaps.Map('js-map', {
                    center: [55.695580, 37.421847],
                    zoom: 16,
                    controls: ['smallMapDefaultSet']
                });

                myMap.geoObjects.add(new ymaps.Placemark([55.695580, 37.421847], {
                    balloonContent: 'Центральный офис, г. Москва',
                }, {
                    // preset: 'islands#redDotIconWithCaption',
                    iconLayout: 'default#imageWithContent',
                    iconImageHref: '../img/marker.svg',
                    iconImageSize: [30, 42],
                }))
            }
        },
        onDestroy() {

        },
    })

}
